export const FIREBASE_ARRAY_CONTAINS_LIMIT = 10;
export const FIREBASE_MAX_BATCH_SIZE = 500;
